import { render } from "./view.vue?vue&type=template&id=693d75c5&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=693d75c5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-693d75c5"

export default script